import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VForm,[_c(VTextField,{attrs:{"label":_vm.t('inventories.marketAreas.dialog.form.general.name'),"required":"","error-messages":_vm.errors.get('name')},model:{value:(_vm.marketAreaInputModel.name),callback:function ($$v) {_vm.$set(_vm.marketAreaInputModel, "name", $$v)},expression:"marketAreaInputModel.name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }